/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeopleGroupCircleAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M9 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
        <path d="M14 6a3 3 0 1 1-1.501 5.598l1.002-1.73a1 1 0 1 0-.368-1.366l-1.73-1.003A3 3 0 0 1 14 6z" />
        <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM9 17c-.871 0-1.67.398-2.226 1.055a7.965 7.965 0 0 0 5.22 1.944C11.893 18.285 10.55 17 9 17zm3-13a8 8 0 0 0-6.57 12.563A4.88 4.88 0 0 1 9 15c2.657 0 4.762 2.128 4.98 4.752a7.97 7.97 0 0 0 3.02-1.51V18.2a3.2 3.2 0 0 0-4.571-2.892L11.57 13.5a5.202 5.202 0 0 1 7.108 2.9A8 8 0 0 0 12 4z" />
      </g>
    </g>
  </Icon>
);
export { SvgPeopleGroupCircleAlt as PeopleGroupCircleAlt };
